import axios, { buildApi } from '@/libs/api.request';
let name = '/doubleClearance/adjust/'

export const apis = buildApi({
  get: [name + 'index/:awbno&list', name + 'detail/:id&detail', name + 'src/:id&src',name + 'print/:id&print', name + 'select/:awbno&select'],
  post: [name + '/save', name + '/delete/:id&del']
})

export const upgradeFeesItem = (params) => {
  return axios.request({
    url: `/finance/upgradeFeesItem`,
    method: "post",
    params,
  });
};

export const removeFeesItem = (params) => {
  return axios.request({
    url: `/finance/upgradeFeesItem`,
    method: "delete",
    params,
  });
};

export const removeScanned = (params) => {
  return axios.request({
    url: `/doubleClearance/adjust/removeScanned`,
    method: "post",
    params,
  });
};
